/**
 * Shared constants for Hyperliquid integration.
 * Hyperliquid only supports USDC on Arbitrum for deposits and withdrawals.
 */

// Asset configuration
export const HYPERLIQUID_SUPPORTED_ASSET = {
  chain: 'arbitrum' as const,
  chainId: 42161,
  address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  symbol: 'USDC',
  name: 'USD Coin',
  decimals: 6,
  assetId: 'usd_coin', // For asset metadata queries
  imgUrl: 'https://coin-images.coingecko.com/coins/images/6319/large/usdc.png',
} as const;

// Transaction limits
export const MINIMUM_WITHDRAWAL_AMOUNT = 5; // Cannot be below 5
export const MINIMUM_DEPOSIT_AMOUNT = 10; // Cannot be below 10

// Balance refresh intervals (in milliseconds)
export const BALANCE_REFETCH_INTERVAL = 6000; // 6 seconds
export const BALANCE_STALE_TIME = 5000; // 5 seconds
export const BALANCE_REFETCH_ON_WINDOW_FOCUS = true;

// Polling intervals
export const SWIDGE_POLL_INTERVAL = 2000; // 2 seconds for swidge status

export const HYPERLIQUID_WITHDRAWAL_FEE = 1; // $1 USD fee charged by Hyperliquid
